import React, { useState } from "react";
import "./Quality_Management_Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom"; // ✅ added
import { useSelector } from "react-redux";
import { FixIDS } from "../../../../utils/fixIDS";

/* ================= MENU DATA ================= */
const QUALITY_MENU = {
  general: [
    {
      label: "Imperiality",
      Link: "general-requirement/imperiality",
      permission_ids: [FixIDS.imperiaity.List],
    },
    {
      label: "Confidentiality",
      Link: "general-requirement/confidentiality",
      permission_ids: [FixIDS.confidentiality.List],
    },
  ],

  structural: [
    {
      label: "Legal Entity",
      Link: "structural-requirement/legel-entity",
      permission_ids: [FixIDS.legel_entity.List],
    },
    {
      label: "Organization Chart",
      Link: "structural-requirement/organization-chart",
      permission_ids: [FixIDS.organization_chart.List],
    },
    {
      label: "Quality Policy",
      Link: "structural-requirement/quality-policy",
      permission_ids: [FixIDS.quality_policy.List],
    },
    {
      label: "Objectives",
      Link: "tructural-requirement/objectives",
      permission_ids: [FixIDS.objectives.List],
    },
    {
      label: "Management Data",
      children: [
        {
          label: "Scope of the Laboratory",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/scope-of-the-laboratory",
          permission_ids: [FixIDS.scope_of_laboratory.List],
        },
        {
          label: "Quality Manual",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/quality-manual",
          permission_ids: [FixIDS.quality_manual.List],
        },
        {
          label: "Procedure Manual",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/procedure-manual",
          permission_ids: [FixIDS.procedure_manual.List],
        },
        {
          label: "IS Standard",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/is-standard",
          permission_ids: [FixIDS.is_standard.List],
        },
        {
          label: "SOP",
          Link:
            "structural-requirement/general-requirement/management-date-confidentiality/sop",
          permission_ids: [FixIDS.sop.List],
        },
      ],
    },
  ],

  resource: [
    {
      label: "Personal Details",
      Link: "resource-requirement/personnel-details",
      permission_ids: [FixIDS.personnel_details.List],
    },
    {
      label: "Environment Condition",
      Link: "resource-requirement/environment-condition",
      permission_ids: [FixIDS.environmental_condition.List],
    },
    { label: "Equipments", Link: "resource-requirement/equipments" ,
      permission_ids: [FixIDS.intermediate_check.List],
    },
    {
      label: "Metrological traceability",
      Link: "resource-requirement/metrological-traceability",
      permission_ids: [FixIDS.metrological_traceability.List],
    },
    {
      label: "Externally Provided Product & Service",
      Link: "resource-requirement/externally-service",
      permission_ids: [FixIDS.externally_provided.List],
    },
  ],

  process: [
    {
      label: "Review of Request, Tenders and Contract",
      Link: "process-requirement/review-contract",
      permission_ids: [FixIDS.review_of_request.List],
    },
    {
      label: "Selection Verification & Validation of Method",
      Link: "process-requirement/selection-method",
      permission_ids: [FixIDS.repeatability.List],
    },
    { label: "Quality Control Plan", Link: "process-requirement/quality-plan",
      permission_ids: [FixIDS.quality_control_plan.List],
     },
    {
      label: "Handling of Test or Calibration Item",
      Link: "process-requirement/handling-item",
      permission_ids: [FixIDS.calibration_item.List],
    },
    {
      label: "Measurement Uncertainty",
      Link: "process-requirement/measurement-uncertainty",
      permission_ids: [FixIDS.measurement_uncertainty.List],
    },
    {
      label: "Ensuring the Validity of Results",
      Link: "process-requirement/ensuring-results",
      permission_ids: [FixIDS.ensuring_the_validity.List],
    },
    { label: "Complaints", Link: "process-requirement/Complaints",
      permission_ids: [FixIDS.complaint.List],
     },
    { label: "Non Confirming Work", Link: "process-requirement/non-work" ,
      permission_ids: [FixIDS.non_confirming_work.List],
    },
  ],
};

const MENU_HEADER_LINKS = {
  managementRequirement: "/quality/management",
};

const Quality_Management_Sidebar = () => {
  const userPermissions = useSelector((state) => state.auth.permissions);

  const location = useLocation(); // ✅ added
  const currentPath = location.pathname;

  const normalizePermissions = (permission_ids) => {
    if (!permission_ids) return [];
    return Array.isArray(permission_ids) ? permission_ids : [permission_ids];
  };

  const hasPermission = (nav) => {
    const required = normalizePermissions(nav?.permission_ids);
    if (required.length === 0) return true;
    return required.some((id) => userPermissions?.includes(id));
  };

  /* ✅ ACTIVE LOGIC (URL based) */
  const isActive = (link) => {
    return currentPath.includes(link);
  };

  /* ✅ DEFAULT OPEN MENU BASED ON URL */
  const getDefaultMenu = () => {
    if (currentPath.includes("general-requirement")) return "general";
    if (currentPath.includes("structural-requirement")) return "structural";
    if (currentPath.includes("resource-requirement")) return "resource";
    if (currentPath.includes("process-requirement")) return "process";
    return "general";
  };

  const [openMenu, setOpenMenu] = useState(getDefaultMenu());
  const [openManagement, setOpenManagement] = useState(true);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };

  const renderSubMenu = (menuKey) => (
    <div className="submenu">
      {QUALITY_MENU[menuKey]
        .filter((item) => {
          if (item.children) {
            return item.children.some((child) => hasPermission(child));
          }
          return hasPermission(item);
        })
        .map((item, index) => {
          if (item.children) {
            return (
              <div className="submenu_group" key={index}>
                <button
                  className={`submenu_item has_child menu_header ${
                    openManagement ? "active" : ""
                  }`}
                  onClick={() => setOpenManagement(!openManagement)}
                >
                  {item.label}
                  <span className="arrow">
                    <FontAwesomeIcon
                      icon={openManagement ? faAngleDown : faAngleRight}
                    />
                  </span>
                </button>

                {openManagement && (
                  <div className="nested_submenu">
                    {item.children
                      .filter((child) => hasPermission(child))
                      .map((child, i) => (
                        <Link
                          to={`/quality-management/${child.Link}`} // ✅ fixed path
                          key={i}
                        >
                          <button
                            className={`submenu_item nested ${
                              isActive(child.Link) ? "active" : "" // ✅ changed
                            }`}
                          >
                            {child.label}
                          </button>
                        </Link>
                      ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <Link
              to={`/quality-management/${item.Link}`} // ✅ fixed path
              key={index}
            >
              <button
                className={`submenu_item ${
                  isActive(item.Link) ? "active" : "" // ✅ changed
                }`}
              >
                {item.label}
              </button>
            </Link>
          );
        })}
    </div>
  );

  return (
    <aside className="common_sidemenu">
      {Object.keys(QUALITY_MENU).map((menu) => (
        <div className="menu_section" key={menu}>
          <button
            className={`menu_header ${openMenu === menu ? "active" : ""}`}
            onClick={() => toggleMenu(menu)}
          >
            {menu.charAt(0).toUpperCase() + menu.slice(1)} Requirement
            <span className="arrow">
              <FontAwesomeIcon
                icon={openMenu === menu ? faAngleDown : faAngleRight}
              />
            </span>
          </button>

          {openMenu === menu && renderSubMenu(menu)}
        </div>
      ))}

      <Link to="/quality-management/management-system-requirement">
        <div className="menu_section">
          <button className={"menu_header "}>
            Management System Requirement
          </button>
        </div>
      </Link>
    </aside>
  );
};

export default Quality_Management_Sidebar;